module.exports = __webpack_public_path__ + "img/logoseebmontesclaros.fb3bc718.png";